/**
 * tr.ts
 *
 * NE İŞE YARAR : Arayüzün **bütün** Türkçe metinleri — anahtar/değer, tek dosya
 * KAYNAK SPEC  : 15-arayuz-standardi.md §14 (dil) · §9.1 (hata mesajı kuralı)
 *                §15 (kimlik doğrulama ekranları) · §15.1 (kurallar)
 * BAĞLI OLDUĞU : — (saf veri; hiçbir bileşeni tanımaz)
 * KULLANAN     : src/metin/index.ts üzerinden bütün ekranlar
 * DİKKAT       : 1) KOD İÇİNE SABİT METİN YAZILMAZ (`15` §14 — **yasak**). Bir ekranda
 *                   doğrudan yazılmış tek bir metin, ikinci dil eklendiğinde o ekranın
 *                   yeniden elden geçirilmesi demektir. `15` §14 baştan kurmanın
 *                   maliyetini ~%10, sonradan yapmanın maliyetini kat kat fazla sayıyor.
 *                2) ANAHTAR EKRANA GÖRE ÖNEKLENİR (`giris.*`, `dogrulama.*`). Düz bir
 *                   isim listesi büyüdükçe hangi metnin nerede kullanıldığı bulunamaz
 *                   hâle gelir ve kullanılmayan metinler dosyada birikir.
 *                3) SUNUCUDAN GELEN HATA MESAJI BURADA **YOKTUR** (`15` §9.1). `04` §9
 *                   her kısıt için kullanıcı mesajını sunucu tarafında yazıyor; arayüz
 *                   onu **olduğu gibi gösterir**. Buradaki hata metinleri yalnız sunucuya
 *                   hiç ulaşılamadığı ya da ekranın bağlama özgü bir şey söylemesi
 *                   gerektiği durumlar içindir — `giris.reddedildi` bunun örneğidir.
 *                4) `{...}` YER TUTUCUDUR ve `metin()` tarafından doldurulur. Metnin
 *                   içine sayı veya ad birleştirilmez: birleştirilen cümle, sözcük
 *                   sırası değişen bir dile çevrilemez.
 * SON GÜNCELLEME: 2026-08-31 02:55:00
 */

/**
 * Metin sözlüğü.
 *
 * `as const` bilinçli: anahtar kümesi tipe dönüşür ve var olmayan bir anahtar
 * **derlemede** yakalanır. `Record<string, string>` olsaydı yazım hatası ancak ekranda
 * boş bir alan olarak görünürdü.
 */
import { UYGULAMA_ADI } from '../marka';

export const TR = {
  // ---- Ortak -------------------------------------------------------------
  // Marka `marka.ts`ten gelir — kural 12: ad ileride değişecek, tek yerde durmalı.
  'ortak.uygulamaAdi': UYGULAMA_ADI,
  'ortak.iptal': 'İptal',
  'ortak.yenidenDene': 'Yeniden dene',

  // ---- Hata durumları (`15` §9) -----------------------------------------
  'hata.baglantiYok': 'Sunucuya ulaşılamıyor. Bağlantınızı kontrol edip yeniden deneyin.',
  'hata.beklenmeyen': 'Beklenmeyen bir hata oluştu. Yeniden deneyin.',
  'hata.izlemeKodu': 'İzleme kodu: {kod}',

  // ---- Giriş ekranı (`15` §15) ------------------------------------------
  'giris.baslik': 'Giriş yap',
  'giris.aciklama': 'Kurum hesabınızla giriş yapın.',
  'giris.kimlik': 'E-posta veya telefon',
  'giris.kimlikIpucu': 'Personel e-posta, öğrenci telefon numarası ile girer.',
  'giris.parola': 'Parola',
  'giris.gonder': 'Giriş yap',
  'giris.parolamiUnuttum': 'Parolamı unuttum',
  'giris.saglayiciAyrac': 'veya',
  'giris.saglayiciYok':
    'E-posta ile giriş bu kurulumda henüz etkin değil. Kurumunuzun sistem yöneticisine başvurun.',
  'giris.reddedildi':
    'Kimlik bilgileri doğrulanamadı. Bilgilerinizi kontrol edip yeniden deneyin.',
  'giris.cokFazlaDeneme': 'Çok fazla deneme yapıldı. Bir süre bekleyip yeniden deneyin.',
  'giris.smsGonderilemedi':
    'Doğrulama kodu şu anda gönderilemiyor. Kısa bir süre sonra yeniden deneyin.',
  'giris.tanimaNotu':
    'Tarayıcı verilerinizi temizlerseniz veya farklı bir tarayıcı kullanırsanız bu cihaz tanınmaz ve yeniden doğrulama kodu istenir.',

  // ---- İki aşamalı doğrulama (`15` §15, §15.1) --------------------------
  'dogrulama.baslik': 'Doğrulama kodu',
  'dogrulama.aciklama': '{telefon} numarasına 6 haneli bir kod gönderildi.',
  'dogrulama.kod': 'Doğrulama kodu',
  'dogrulama.kalanSure': 'Kodun geçerlilik süresi: {sure}',
  'dogrulama.suresiDoldu': 'Kodun süresi doldu. Yeni kod isteyin.',
  'dogrulama.gonder': 'Doğrula',
  'dogrulama.yenidenGonder': 'Kodu yeniden gönder',
  'dogrulama.yenidenGonderBekle': 'Kodu yeniden gönder ({sure})',
  'dogrulama.yenidenGonderildi': 'Yeni kod gönderildi. Önceki kod artık geçersiz.',
  'dogrulama.kodHatali': 'Kod doğrulanamadı. Kalan deneme hakkı: {kalan}',
  'dogrulama.kodGecersiz': 'Kod üç kez yanlış girildiği için geçersiz oldu. Yeni kod isteyin.',
  'dogrulama.cokSik': 'Yeni kod istemek için biraz beklemeniz gerekiyor.',
  'dogrulama.bulunamadi': 'Bu doğrulama isteği artık geçerli değil. Baştan giriş yapın.',
  'dogrulama.cihaziHatirla': 'Bu cihazı 60 gün hatırla',
  'dogrulama.cihazAdi': 'Cihaz adı',
  'dogrulama.cihazAdiUyari': 'Kişisel bilgi yazmayınız.',
  'dogrulama.cihazAdiYerTutucu': 'Ofis bilgisayarı',

  // ---- Cihaz sınırı (`15` §15.1) ----------------------------------------
  'cihaz.sinirBaslik': 'Cihaz sınırına ulaşıldı',
  'cihaz.sinirMetin':
    'En fazla 1 web cihazı kaydedebilirsiniz. Yeni cihaz eklemek için mevcut cihazı kaldırın.',
  'cihaz.listeyeGit': 'Cihazlarıma git',

  // ---- Cihazlarım (`15` §15 · `04` M2-09, M2-10) ------------------------
  'cihazlar.baslik': 'Cihazlarım',
  'cihazlar.aciklama':
    'Tanınan cihazlar 60 gün boyunca doğrulama kodu istemez. Kaldırılan cihazın açık oturumu hemen kapanır.',
  'cihazlar.ad': 'Cihaz',
  'cihazlar.tur': 'Tür',
  'cihazlar.sonGorulme': 'Son görülme',
  'cihazlar.gecerlilik': 'Geçerlilik sonu',
  'cihazlar.buCihaz': 'Bu cihaz',
  'cihazlar.kaldir': 'Kaldır',
  'cihazlar.bos': 'Kayıtlı cihazınız yok. Bir sonraki girişinizde doğrulama kodu istenir.',
  'cihazlar.turWeb': 'Web',
  'cihazlar.turMobil': 'Mobil',
  'cihazlar.kaldirBaslik': 'Cihaz kaldırılsın mı?',
  'cihazlar.kaldirMetin': 'Bu cihaz bir daha tanınmaz ve sonraki girişte doğrulama kodu istenir.',
  'cihazlar.kaldirKendisiMetin':
    'Bu, şu anda kullandığınız cihazdır. Kaldırıldığında oturumunuz hemen kapanır ve yeniden giriş yapmanız gerekir.',
  'cihazlar.kaldirildi': 'Cihaz kaldırıldı.',

  // ---- Parola sıfırlama (`15` §15) --------------------------------------
  'sifirlamaTalebi.baslik': 'Parolamı unuttum',
  'sifirlamaTalebi.aciklama':
    'Hesabınıza kayıtlı telefon numarasını girin. Numara sistemde kayıtlıysa sıfırlama bağlantısı gönderilir.',
  'sifirlamaTalebi.telefon': 'Telefon numarası',
  'sifirlamaTalebi.gonder': 'Sıfırlama bağlantısı iste',
  'sifirlamaTalebi.alindi': 'İsteğiniz alındı',
  'sifirlamaTalebi.alindiMetin':
    'Numara sistemde kayıtlıysa sıfırlama bağlantısı gönderildi. Bağlantı 15 dakika geçerlidir.',
  'sifirlamaTalebi.girisEkranina': 'Giriş ekranına dön',

  'sifirlama.baslik': 'Yeni parola belirle',
  'sifirlama.aciklama': 'Parolanız en az 12 karakter olmalıdır.',
  'sifirlama.yeniParola': 'Yeni parola',
  'sifirlama.yeniParolaTekrar': 'Yeni parola (tekrar)',
  'sifirlama.gonder': 'Parolayı değiştir',
  'sifirlama.eslesmiyor': 'İki parola aynı değil.',
  'sifirlama.jetonYok': 'Sıfırlama bağlantısı eksik. Bağlantıyı size gönderildiği hâliyle açın.',
  'sifirlama.jetonGecersiz':
    'Bu sıfırlama bağlantısı geçerli değil. Süresi dolmuş veya daha önce kullanılmış olabilir.',
  'sifirlama.tamam': 'Parolanız değiştirildi',
  'sifirlama.tamamMetin':
    'Güvenlik gereği bütün oturumlarınız ve tanınan cihazlarınız kapatıldı. Yeni parolanızla giriş yapın.',

  // ---- Parola politikası ihlalleri (`04` AU-05 · ADR-019 §3) ------------
  'parola.kisa': 'Parola en az 12 karakter olmalıdır.',
  'parola.sizmis': 'Bu parola bilinen bir veri sızıntısında yer alıyor. Başka bir parola seçin.',
  'parola.gecmiste': 'Son 5 parolanızdan birini yeniden kullanamazsınız.',
  'parola.kontrolEdilemedi':
    'Parola güvenlik kontrolü şu anda yapılamıyor. Kısa bir süre sonra yeniden deneyin.',

  // ---- Liste ekranı ortak (`15` §8) --------------------------------------
  'ortak.durum': 'Durum',
  'filtre.hepsi': 'Hepsi',
  'sutun.ad': 'Ad',
  'sutun.soyad': 'Soyad',
  'sutun.cinsiyet': 'Cinsiyet',
  'sutun.kimlikNo': 'Kimlik no',
  'sutun.dogumTarihi': 'Doğum tarihi',
  'sutun.ogrenciNo': 'Öğrenci no',
  'sutun.kayitTarihi': 'Kayıt tarihi',
  'sutun.ayrilisTarihi': 'Ayrılış tarihi',
  'sutun.basvuruTuru': 'Başvuru türü',
  'sutun.burslu': 'Burslu',
  'sutun.oncelikli': 'Öncelikli',
  'sutun.gonderimTarihi': 'Gönderim tarihi',
  'sutun.bekleyenSira': 'Bekleme sırası',
  'sutun.kararTarihi': 'Karar tarihi',
  'sutun.kod': 'Kod',
  'sutun.adi': 'Adı',
  'sutun.basvuruAraligi': 'Başvuru aralığı',
  'sutun.belgeTuru': 'Belge türü',
  'sutun.not': 'Not',

  // ---- Durum adları — sunucu kodlarının Türkçesi -------------------------
  'durumAd.arsivlendi': 'Arşivlendi',
  'durumAd.kisiActive': 'Etkin',
  'durumAd.kisiMerged': 'Birleştirildi',
  'durumAd.kisiAnonymized': 'Anonimleştirildi',
  'durumAd.ogrenciCandidate': 'Aday',
  'durumAd.ogrenciActive': 'Kayıtlı',
  'durumAd.ogrenciOnLeave': 'İzinli',
  'durumAd.ogrenciGraduated': 'Mezun',
  'durumAd.ogrenciLeft': 'Ayrıldı',
  'durumAd.basvuruDraft': 'Taslak',
  'durumAd.basvuruSubmitted': 'Gönderildi',
  'durumAd.basvuruUnderReview': 'Değerlendirmede',
  'durumAd.basvuruNeedsInfo': 'Eksik bilgi',
  'durumAd.basvuruAccepted': 'Kabul edildi',
  'durumAd.basvuruWaitlisted': 'Bekleme listesinde',
  'durumAd.basvuruRejected': 'Reddedildi',
  'durumAd.basvuruEnrolled': 'Kesin kayıt',
  'durumAd.basvuruWithdrawn': 'Geri çekildi',
  'durumAd.donemDraft': 'Taslak',
  'durumAd.donemOpen': 'Açık',
  'durumAd.donemClosed': 'Kapalı',

  // ---- Kişi (`04` M3-01, M3-02) -------------------------------------------
  'kisi.aciklama': 'Kayıtlı kişiler. Arama, adın normalleştirilmiş hâli üzerinde önekle çalışır.',
  'kisi.ara': 'Ad veya soyad',
  'kisi.bosBaslik': 'Kişi bulunamadı',
  'kisi.bosAciklama':
    'Aramanızla eşleşen kişi yok. Farklı bir yazımla deneyin veya durum filtresini genişletin.',
  'kisi.detayBaslik': 'Kişi',
  'kisi.kimlikTuru': 'Kimlik türü',
  'kisi.basvurulari': 'Başvurular',
  'kisi.basvurulariGit': 'Bu kişinin başvurularını görüntüle',

  // ---- Öğrenci (`04` M5-01, M5-02) ---------------------------------------
  'ogrenci.aciklama': 'Yurtta kaydı bulunan öğrenciler.',
  'ogrenci.ara':
 'Ad, soyad veya öğrenci no',
  'ogrenci.bosBaslik': 'Öğrenci bulunamadı',
  'ogrenci.bosAciklama':
    'Seçili yetki alanında bu filtrelere uyan öğrenci yok. Kurum seçiminizi veya durumu değiştirin.',
  'ogrenci.detayBaslik': 'Öğrenci',
  'ogrenci.ayrilisGerekcesi': 'Ayrılış gerekçesi',
  // 49. adım — şartlı kaydın belge yükümlülüğü (`05` §6.3 · AK-06).
  'ogrenci.belgeDurumu': 'Belge durumu',
  'ogrenci.belgeAcik': 'Eksik belgesi var',
  'ogrenci.belgeSuresiDoldu': 'Süresi doldu',
  'yerlesim.ozet': 'Yerleşim özeti',
  'yerlesim.yok': 'Bu öğrencinin aktif yerleşimi yok.',
  'yerlesim.tur': 'Yerleşim türü',
  'yerlesim.gecerlilik': 'Geçerlilik aralığı',

  // ---- Başvuru (`04` B-06, B-07) ------------------------------------------
  'basvuru.aciklama': 'Başvurular; öncelikli olanlar ve erken gönderilenler üstte.',
  'basvuru.bosBaslik': 'Başvuru bulunamadı',
  'basvuru.bosAciklama':
    'Bu filtrelere uyan başvuru yok. Dönem veya durum seçimini değiştirin.',
  'basvuru.detayBaslik': 'Başvuru',
  'basvuru.kararGerekcesi': 'Karar gerekçesi',
  'basvuru.kabulGecerlilik': 'Kabul geçerlilik sonu',
  'basvuru.tercihSirasi': 'Tercih sırası',
  'basvuru.belgeler': 'Belgeler',
  'basvuru.belgeBosBaslik': 'Belge yok',
  'basvuru.belgeBosAciklama':
    'Bu başvuruya henüz belge yüklenmemiş. Belge, başvuru sahibinden istenir.',

  // ---- Başvuru dönemi (`04` B-01…B-05) -----------------------------------
  'donem.aciklama': 'Başvuru dönemleri ve açık/kapalı durumları.',
  'donem.bosBaslik': 'Başvuru dönemi yok',
  'donem.bosAciklama': 'Henüz bir başvuru dönemi tanımlanmamış.',

  // ---- Kurum (`04` M1-01) -------------------------------------------------
  'kurum.aciklama': 'Kurum hiyerarşisi. Satırlar hiyerarşi sırasında gelir.',
  'kurum.tur': 'Kurum türü',
  'kurum.derinlik': 'Hiyerarşi derinliği',
  'kurum.bosBaslik': 'Kurum bulunamadı',
  'kurum.bosAciklama': 'Bu filtrelere uyan kurum yok. Tür veya durum seçimini değiştirin.',
  'kurumTur.hq': 'Genel merkez',
  'kurumTur.branch': 'Şube',
  'kurumTur.dorm': 'Yurt',
  'durumAd.kurumActive': 'Etkin',
  'durumAd.kurumClosing': 'Kapanıyor',
  'durumAd.kurumClosed': 'Kapandı',

  // ---- Fiziksel yapı (`04` M6-01…M6-03) ----------------------------------
  'yapi.binalar': 'Binalar',
  'yapi.odalar': 'Odalar',
  'yapi.yataklar': 'Yataklar',
  'yapi.binaAciklama': 'Yurttaki binalar ve cinsiyet politikaları.',
  'yapi.odaAciklama': 'Odalar; doluluk sunucudan hesaplanmış gelir.',
  'yapi.yatakAciklama': 'Yataklar ve durumları.',
  'yapi.cinsiyetPolitikasi': 'Cinsiyet politikası',
  'yapi.kapasite': 'Kapasite',
  'yapi.dolu': 'Dolu',
  'yapi.odaTuru': 'Oda türü',
  'yapi.erisilebilir': 'Erişilebilir',
  'yapi.binaBosBaslik': 'Bina yok',
  'yapi.binaBosAciklama': 'Seçili yetki alanında kayıtlı bina bulunmuyor.',
  'yapi.odaBosBaslik': 'Oda yok',
  'yapi.odaBosAciklama': 'Seçili yetki alanında kayıtlı oda bulunmuyor.',
  'yapi.yatakBosBaslik': 'Yatak yok',
  'yapi.yatakBosAciklama':
    'Bu filtrelere uyan yatak yok. Durum veya cinsiyet seçimini değiştirin.',
  'cinsiyet.erkek': 'Erkek',
  'cinsiyet.kadin': 'Kadın',
  'cinsiyet.karma': 'Karma',
  'durumAd.yapiMaintenance': 'Bakımda',
  'durumAd.yatakAvailable': 'Boş',
  'durumAd.yatakOccupied': 'Dolu',
  'durumAd.yatakOutOfService': 'Hizmet dışı',

  // ---- Yerleşim (`04` M7-01, M7-02) --------------------------------------
  'yerlesim.aciklama': 'Yerleşim kayıtları; en yeni önce.',
  'yerlesim.detayBaslik': 'Yerleşim',
  'yerlesim.ogrenciCinsiyeti': 'Öğrenci cinsiyeti',
  'yerlesim.yatakPolitikasi': 'Yatak politikası',
  'yerlesim.onayTarihi': 'Onay tarihi',
  'yerlesim.bosBaslik': 'Yerleşim bulunamadı',
  'yerlesim.bosAciklama': 'Bu filtrelere uyan yerleşim yok. Durum seçimini değiştirin.',
  'yerlesim.duzeltmeler': 'Düzeltme geçmişi',
  'yerlesim.duzeltmeYok': 'Bu yerleşimde düzeltme yok.',
  'yerlesim.duzeltmeSuzgeci': 'Düzeltme talebi',
  'yerlesim.duzeltmeBekleyen': 'Bekleyen talebi var',
  'yerlesim.duzeltmeBeklemeyen': 'Bekleyen talebi yok',
  'durumAd.yerlesimDraft': 'Taslak',
  'durumAd.yerlesimPending': 'Onay bekliyor',
  'durumAd.yerlesimActive': 'Aktif',
  'durumAd.yerlesimEnded': 'Sonlandı',
  'durumAd.yerlesimRejected': 'Reddedildi',
  'durumAd.yerlesimCancelled': 'İptal edildi',

  // ---- Veli ve rıza — kişi ekranının alt bölümleri -----------------------
  'veli.baslik': 'Veliler',
  'veli.iliskiTuru': 'Yakınlık',
  'veli.yasalVeli': 'Yasal veli',
  'veli.acilDurum': 'Acil durum kişisi',
  'veli.dogrulamaZamani': 'Doğrulama zamanı',
  'veli.bosBaslik': 'Veli kaydı yok',
  'veli.bosAciklama': 'Bu kişiye bağlı veli ilişkisi tanımlanmamış.',
  'riza.baslik': 'Rıza kayıtları',
  'riza.tur': 'Rıza türü',
  'riza.verilme': 'Verilme zamanı',
  'riza.geriAlma': 'Geri alma zamanı',
  'riza.bosBaslik': 'Rıza kaydı yok',
  'riza.bosAciklama': 'Bu kişi için kayıtlı bir rıza beyanı bulunmuyor.',

  // ---- IAM (`04` M2-01, M2-04, M2-07) ------------------------------------
  'iam.kullaniciAciklama': 'Sisteme giriş yapabilen hesaplar.',
  'iam.kullaniciBosBaslik': 'Kullanıcı bulunamadı',
  'iam.kullaniciBosAciklama': 'Bu filtrelere uyan kullanıcı yok. Durum seçimini değiştirin.',
  'iam.rolAciklama': 'Sistem rolleri ve izin kümeleri. Bu liste sabittir.',
  'iam.rolBosBaslik': 'Rol yok',
  'iam.rolBosAciklama': 'Rol kataloğu okunamadı.',
  'iam.oturumAciklama': 'Açık ve kapanmış oturumlar; en son görülen önce.',
  'iam.oturumBosBaslik': 'Oturum yok',
  'iam.oturumBosAciklama': 'Görüntülenebilecek oturum kaydı bulunmuyor.',
  'iam.kimlikKaynagi': 'Kimlik kaynağı',
  'iam.kisiKaydi': 'Kişi kaydı',
  'iam.sistemRolu': 'Sistem rolü',
  'iam.dogrulamaSeviyesi': 'Doğrulama',
  'iam.acilis': 'Açılış',
  'iam.iptalTarihi': 'İptal tarihi',
  'durumAd.kullaniciInvited': 'Davet edildi',
  'durumAd.kullaniciActive': 'Etkin',
  'durumAd.kullaniciSuspended': 'Askıda',
  'durumAd.kullaniciDisabled': 'Kapatıldı',

  // ---- Denetim ve KVKK (`04` X-01, D-*) ----------------------------------
  'kvkk.denetimAciklama':
    'Denetim kayıtları. Bu listeyi görüntülemek de bir erişim kaydı üretir; sayfa kendiliğinden yenilenmez.',
  'kvkk.denetimBosBaslik': 'Denetim kaydı bulunamadı',
  'kvkk.denetimBosAciklama':
    'Bu filtrelere uyan kayıt yok. Varlık türü veya işlem seçimini değiştirin.',
  'kvkk.varlikTuru': 'Varlık türü',
  'kvkk.islem': 'İşlem',
  'kvkk.sonuc': 'Sonuç',
  'kvkk.retSebebi': 'Ret sebebi',
  'kvkk.degisenAlanlar': 'Değişen alanlar',
  'kvkk.olayZamani': 'Olay zamanı',
  'kvkk.olayAciklama': 'Güvenlik olayları; en yeni önce.',
  'kvkk.olayBosBaslik': 'Güvenlik olayı yok',
  'kvkk.olayBosAciklama': 'Bu filtrelere uyan olay yok. Durum veya şiddet seçimini değiştirin.',
  'kvkk.olayTuru': 'Olay türü',
  'kvkk.siddet': 'Şiddet',
  'siddet.p0': 'P0 — en yüksek',
  'siddet.p1': 'P1',
  'siddet.p2': 'P2',
  'siddet.p3': 'P3',
  'durumAd.olayOpen': 'Açık',
  'durumAd.olayInvestigating': 'İnceleniyor',
  'durumAd.olayResolved': 'Çözüldü',
  'durumAd.olayFalsePositive': 'Yanlış alarm',
  'kvkk.talepAciklama': 'Veri sahibi talepleri; süresi en yakın olan önce.',
  'kvkk.talepBosBaslik': 'Veri talebi yok',
  'kvkk.talepBosAciklama': 'Bu filtrelere uyan talep yok. Durum seçimini değiştirin.',
  'kvkk.talepTuru': 'Talep türü',
  'kvkk.kararGerekcesi': 'Karar gerekçesi',
  'kvkk.alinmaZamani': 'Alınma zamanı',
  'kvkk.sonTarih': 'Son tarih',
  'durumAd.talepReceived': 'Alındı',
  'durumAd.talepInReview': 'İncelemede',
  'durumAd.talepFulfilled': 'Karşılandı',
  'durumAd.talepPartial': 'Kısmen karşılandı',
  'durumAd.talepRejected': 'Reddedildi',
  'kvkk.muhafazaAciklama':
    'Hukuki muhafaza kayıtları. Varsayılan olarak yalnız aktif olanlar görünür.',
  'kvkk.muhafazaBosBaslik': 'Hukuki muhafaza yok',
  'kvkk.muhafazaBosAciklama': 'Aktif bir hukuki muhafaza kaydı bulunmuyor.',
  'kvkk.kaldirilanlar': 'Kaldırılanlar',
  'kvkk.kaldirilanlarDahil': 'Kaldırılanlar da gösterilsin',
  'kvkk.konmaZamani': 'Konma zamanı',
  'kvkk.kaldirilmaZamani': 'Kaldırılma zamanı',

  // ---- Ana ekran (`15` §6) -----------------------------------------------
  'ana.baslik': 'Ana ekran',
  'ana.bekleyenIsler': 'Bekleyen işler',
  'ana.bekleyenYok': 'Bekleyen işiniz yok.',
  'ana.yerlesimOnay': 'Onay bekleyen yerleşim',
  'ana.basvuruDegerlendirme': 'Değerlendirme bekleyen başvuru',
  'ana.basvuruEksikBilgi': 'Eksik bilgi bekleyen başvuru',
  'ana.guvenlikOlayi': 'Açık güvenlik olayı',
  'ana.veriTalebi': 'Bekleyen veri talebi',
  'ana.eksikBelge': 'Eksik belgeli kayıt',
  'ana.belgeSuresiDolan': 'Süresi dolan şartlı kayıt',
  'ana.bekleyenDuzeltme': 'Bekleyen düzeltme talebi',
  'ana.dolulukOzeti': 'Doluluk özeti',
  'ana.toplamYatak': 'Toplam yatak',
  'ana.dolu': 'Dolu',
  'ana.bosYatak': 'Boş',
  'ana.krizKapasite': 'Kriz yatağı',
  'ana.krizDolu': 'Kriz yatağı dolu',
  'ana.mevcutlukNotu':
    'Sayılar her açılışta canlı sorgudan gelir. O an yurtta bulunan kişi sayısı Faz 1’de hesaplanamadığı için gösterilmez.',

  // ---- Durum ekranları (`15` §9) ----------------------------------------
  'durum.bosBaslik': 'Gösterilecek kayıt yok',
  'durum.bosAciklama': 'Filtreleri değiştirerek yeniden deneyebilirsiniz.',
  'durum.hataBaslik': 'İşlem tamamlanamadı',
  'durum.yetkisizBaslik': 'Görüntüleme yetkiniz yok',
  'durum.yetkisizAciklama':
    'Bu kaydı görüntüleme yetkiniz bulunmuyor. Yetki talebi için kurumunuzun sürecini izleyin.',
  'durum.bulunamadiBaslik': 'Kayıt bulunamadı',
  'durum.bulunamadiAciklama':
    'Böyle bir kayıt yok veya yetki alanınızın dışında. Bağlantıyı kontrol edin.',
  'durum.baglantiBaslik': 'Sunucuya ulaşılamıyor',
  'durum.baglantiAciklama':
    'Bağlantınızı kontrol edip yeniden deneyin. Yazdıklarınız korunuyor.',

  // ---- Gerekçe alanı (`15` §10.1) ---------------------------------------
  'gerekce.etiket': 'Gerekçe',
  'gerekce.aciklama': 'Bu gerekçe denetim kaydına işlenir ve silinemez.',
  'gerekce.zorunlu': 'Bu işlem için gerekçe zorunludur.',

  // ---- Kabuk: menü (`15` §5.2) ------------------------------------------
  'menu.anaEkran': 'Ana ekran',
  'menu.grupKayit': 'Kayıt ve öğrenci',
  'menu.grupYerlesim': 'Yerleşim',
  'menu.grupKurum': 'Kurum',
  'menu.grupYonetim': 'Yönetim',
  'menu.grupDenetim': 'Denetim ve KVKK',
  'menu.basvurular': 'Başvurular',
  'menu.basvuruDonemleri': 'Başvuru dönemleri',
  'menu.kisiler': 'Kişiler',
  'menu.ogrenciler': 'Öğrenciler',
  'menu.yerlesimler': 'Yerleşimler',
  'menu.yapi': 'Binalar, odalar, yataklar',
  'menu.kurumlar': 'Kurumlar',
  'menu.kullanicilar': 'Kullanıcılar',
  'menu.roller': 'Roller',
  'menu.oturumlar': 'Oturumlar',
  'menu.denetim': 'Denetim kayıtları',
  'menu.guvenlikOlaylari': 'Güvenlik olayları',
  'menu.veriTalepleri': 'Veri talepleri',
  'menu.hukukiMuhafaza': 'Hukuki muhafaza',

  // ---- Kabuk: scope seçici (`15` §5.3) ----------------------------------
  'scope.etiket': 'Çalışılan kurum',
  'scope.tumu': 'Tüm yetki alanım',

  // ---- Oturum özeti ------------------------------------------------------
  'oturum.cikis': 'Çıkış yap',
  'oturum.baslik': 'Oturum açık',
  'oturum.aciklama':
    'Bu sayfa oturumun kimin adına açıldığını ve hangi izinlerle çalıştığınızı gösterir. Menü ve ekranlardaki butonlar bu izinlere göre kurulur.',
  'oturum.eposta': 'E-posta',
  'oturum.telefon': 'Telefon',
  'oturum.hesapDurumu': 'Hesap durumu',
  'oturum.sonGiris': 'Son giriş',
  'oturum.dogrulamaSeviyesi': 'Doğrulama',
  'oturum.roller': 'Yetki alanları',
  'oturum.rolYok': 'Bu hesaba henüz yetki alanı atanmamış.',
  'oturum.izinSayisi': 'İzin kodu: {sayi}',
  'oturum.cihazlarim': 'Cihazlarım',

  // ---- Yerleşim işlemleri (33., 35. adım) --------------------------------
  'yerlesim.teklifEt': 'Yerleşim öner',
  'yerlesim.ogrenciKimligi': 'Öğrenci kimliği',
  'yerlesim.yatakKimligi': 'Yatak kimliği',
  'yerlesim.turNormal': 'Normal',
  'yerlesim.turGecici': 'Geçici',
  'yerlesim.turKriz': 'Kriz',
  'yerlesim.onayla': 'Onayla',
  'yerlesim.reddet': 'Reddet',
  'yerlesim.iptalEt': 'Talebi iptal et',
  'yerlesim.iptalNeOlacak':
    'Yerleşim talebi iptal edilecek ve yatak yeniden boşa çıkacak.',
  'yerlesim.iptalNeKalacak':
    'Kayıt silinmez: talep geçmişte iptal edilmiş olarak görünmeye devam eder.',
  'yerlesim.tasi': 'Başka yatağa taşı',
  'yerlesim.hedefYatak': 'Hedef yatak kimliği',
  'yerlesim.gecerlilikBaslangici': 'Taşıma anı',
  'yerlesim.sonlandir': 'Yerleşimi sonlandır',
  'yerlesim.bitisAni': 'Bitiş anı',
  'yerlesim.sonlandirNeOlacak':
    'Yerleşim sonlandırılacak ve yatak bu andan sonrası için boşalacak.',
  'yerlesim.sonlandirNeKalacak':
    'Geçmiş konaklama kaydı silinmez; sonlandırma tarihi ve gerekçesi kayda işlenir.',
  'yerlesim.bosYatakAra': 'Boş yatak ara',

  // ---- Yerleşim düzeltme (36. adım) --------------------------------------
  'duzeltme.talepEt': 'Düzeltme iste',
  'duzeltme.tur': 'Düzeltme türü',
  'duzeltme.turFieldFix': 'Alan düzeltmesi — gerekçe metni',
  'duzeltme.turPeriodAdjust': 'Süre düzeltmesi — geçerlilik aralığı',
  'duzeltme.turReversal': 'Kaydı geri alma — alan düzeltilmez',
  'duzeltme.yeniDeger': 'Yeni değer',
  'duzeltme.yeniDegerAciklama':
    'Alan düzeltmesinde yeni gerekçe metni, süre düzeltmesinde yeni geçerlilik aralığı yazılır. Kaydı geri almada boş bırakılır.',
  'duzeltme.onayla': 'Düzeltmeyi onayla',
  'duzeltme.reddet': 'Düzeltmeyi reddet',
  'duzeltme.geriCek': 'Talebi geri çek',
  'duzeltme.onayNeOlacak':
    'Düzeltme onaylanacak ve yerleşim kaydına aynı işlemde uygulanacak.',
  'duzeltme.onayNeKalacak':
    'Özgün kayıt silinmez; düzeltme ayrı bir satır olarak geçmişte kalır.',
  'duzeltme.bekleyen': 'Karar bekliyor',

  // ---- Üst çubuk araması (42. adım) --------------------------------------
  'arama.etiket': 'Kişi ara',
  'arama.yerTutucu': 'Ad veya soyad ile kişi ara',

  // ---- Gezinme uyarısı (43. adım) ----------------------------------------
  'yarimForm.baslik': 'Kaydedilmemiş bilgi var',
  'yarimForm.neOlacak':
    'Bu sayfadan ayrılırsanız yazdıklarınız kaybolur; kayıt sunucuya gönderilmedi.',
  'yarimForm.neKalacak': 'Sayfada kalıp gönderirseniz hiçbir şey kaybolmaz.',
  'yarimForm.ayril': 'Yine de ayrıl',

  // ---- Erişilebilirlik (45. adım) ----------------------------------------
  'erisim.icerigeAtla': 'İçeriğe atla',
  'erisim.anaIcerik': 'Ana içerik',

  // ---- Başvuru işlemleri (37. adım) --------------------------------------
  'basvuru.guncelle': 'Başvuruyu güncelle',
  'basvuru.tur': 'Başvuru türü',
  'basvuru.not': 'Not',
  'basvuru.gonder': 'Başvuruyu gönder',
  'basvuru.gonderNeOlacak':
    'Başvuru sıraya girecek ve gönderim anı sıralamayı belirleyecek.',
  'basvuru.gonderNeKalacak':
    'Gönderim anı sonradan değiştirilemez; eksik bilgi istenirse başvuru düzenlenebilir hâle döner.',
  'basvuru.incelemeyeAl': 'İncelemeye al',
  'basvuru.eksikBilgi': 'Eksik bilgi iste',
  'basvuru.kabulEt': 'Kabul et',
  'basvuru.gecerlilikSonu': 'Kabul geçerlilik sonu',
  'basvuru.gecerlilikAciklama':
    'Kabul kararı gelecekte biten bir geçerlilik tarihi ister; bu tarihe kadar kesin kayıt yapılmazsa kabul düşer.',
  'basvuru.beklemeyeAl': 'Bekleme listesine al',
  'basvuru.reddet': 'Reddet',
  'basvuru.kesinKayit': 'Kesin kayıt yap',
  'basvuru.ogrenciNoAciklama':
    'Boş bırakılırsa numara sunucuda üretilir. Yazılan numara kurumda tekil olmalıdır.',
  'basvuru.kesinKayitNeOlacak':
    'Başvurudan bir öğrenci kaydı açılacak; öğrenci kaydının tek oluşum yolu budur.',
  'basvuru.kesinKayitNeKalacak':
    'Başvuru silinmez; kesin kayıtla ilişkilendirilmiş olarak geçmişte kalır.',
  'basvuru.geriCek': 'Başvuruyu geri çek',
  'basvuru.geriCekNeOlacak': 'Başvuru sıradan çıkarılacak ve değerlendirilmeyecek.',
  'basvuru.geriCekNeKalacak': 'Kayıt silinmez; geri çekilmiş olarak görünmeye devam eder.',

  // ---- Belge işlemleri (38. adım) ----------------------------------------
  'belge.yukle': 'Belge yükle',
  'belge.tur': 'Belge türü',
  'belge.turAciklama': 'Kurumun belge türü kataloğundaki kod.',
  'belge.dosya': 'Dosya',
  'belge.dosyaAciklama': 'Dosya yüklendikten sonra virüs taramasından geçer.',
  'belge.indir': 'İndir',
  'belge.dogrula': 'Belgeyi doğrula',
  'belge.dogrulamaSonucu': 'Doğrulama sonucu',
  'belge.sonucGecerli': 'Geçerli',
  'belge.sonucGecersiz': 'Geçersiz',
  'belge.imhaEdilmis':
    'Bu belgenin içeriği imha edilmiş. Kaydı duruyor ama dosya artık indirilemez.',
  'belge.depoErisilemiyor':
    'Belge deposuna şu an ulaşılamıyor. Belge duruyor; biraz sonra yeniden deneyin.',

  // ---- Kişi ve öğrenci işlemleri (39. adım) ------------------------------
  'kisi.guncelle': 'Kişiyi güncelle',
  'kisi.cinsiyet': 'Cinsiyet',
  'kisi.cinsiyetAciklama':
    'Cinsiyet düzeltmesi gerekçe ister ve aktif yerleşimi olan kişide yapılamaz.',
  'kisi.kimlikDuzeltmeIste': 'Kimlik düzeltmesi iste',
  'kisi.kimlikTcKimlik': 'T.C. kimlik numarası',
  'kisi.kimlikPasaport': 'Pasaport',
  'kisi.kimlikDegeri': 'Yeni kimlik numarası',
  'kisi.pasaportUlkesi': 'Pasaport ülkesi',
  'kisi.birlestir': 'Bu kayıtla birleştir',
  'kisi.kaynakKisi': 'Birleştirilecek kayıt kimliği',
  'kisi.kaynakAciklama':
    'Yazılan kayıt bu kaydın içine taşınır. Hangi kaydın kalacağına dikkat ediniz.',
  'kisi.birlestirNeOlacak':
    'İki kayıt tek kayda indirilecek; ilişkili öğrenci, başvuru ve rıza kayıtları taşınacak.',
  'kisi.birlestirNeKalacak':
    'Birleştirme geri alınabilir; taşınan kayıtlar silinmez, yalnız bağlantıları değişir.',
  'kisi.kimlikOnayla': 'Kimlik düzeltmesini onayla',
  'kisi.kimlikOnayNeOlacak':
    'Kimlik numarası değiştirilecek ve düzeltme aynı işlemde uygulanacak.',
  'kisi.kimlikOnayNeKalacak':
    'Eski kimliğin özeti geçmişte kalır; ham numara hiçbir yere yazılmaz.',
  'kisi.kimlikReddet': 'Kimlik düzeltmesini reddet',
  'kisi.kimlikGeriCek': 'Kimlik talebini geri çek',
  'ogrenci.numara': 'Öğrenci numarası',
  'ogrenci.durumDegistir': 'Durumu değiştir',
  'ogrenci.yeniDurum': 'Yeni durum',
  'ogrenci.durumNeOlacak': 'Öğrencinin durumu değişecek ve değişiklik geçmişe yazılacak.',
  'ogrenci.durumNeKalacak':
    'Kayıt silinmez; önceki durum ve gerekçesi durum geçmişinde kalır.',
  'durumAd.ogrenciSuspended': 'Uzaklaştırıldı',
  'durumAd.ogrenciWithdrawn': 'Kaydı silindi',

  // ---- IAM işlemleri (40. adım) ------------------------------------------
  'iam.kullaniciAc': 'Kullanıcı aç',
  'iam.epostaAciklama':
    'Personel hesabı e-posta ile açılır. Parola belirlenmez; kullanıcı kendisi kurar.',
  'iam.kisiKimligi': 'Kişi kimliği',
  'iam.ogrenciDavet': 'Öğrenci hesabı davet et',
  'iam.ogrenciKimligi': 'Öğrenci kimliği',
  'iam.telefonAciklama': 'Öğrenci telefonla giriş yapar ve parolasını kendisi kurar.',
  'iam.yetkiVer': 'Yetki ver',
  'iam.kullaniciKimligi': 'Kullanıcı kimliği',
  'iam.rolKimligi': 'Rol kimliği',
  'iam.kurumKimligi': 'Kurum kimliği',
  'iam.devreDisiBirak': 'Devre dışı bırak',
  'iam.devreDisiNeOlacak': 'Hesap devre dışı kalacak ve açık oturumları düşecek.',
  'iam.devreDisiNeKalacak':
    'Hesap silinmez; kayıtları, denetim izi ve geçmiş işlemleri olduğu gibi durur.',
  'iam.yetkiGeriAl': 'Yetkiyi geri al',
  'iam.oturumIptal': 'Oturumu iptal et',
  'iam.oturumIptalNeOlacak':
    'Bu oturum hemen kapanacak; kullanıcı çalışıyorsa işini kaybedebilir.',
  'iam.oturumIptalNeKalacak': 'Hesap açık kalır; kullanıcı yeniden giriş yapabilir.',

  // ---- KVKK işlemleri (41. adım) -----------------------------------------
  'kvkk.talepAc': 'Başvuru kaydet',
  'kvkk.turErisim': 'Erişim',
  'kvkk.turDuzeltme': 'Düzeltme',
  'kvkk.turSilme': 'Silme',
  'kvkk.turKisitlama': 'Kısıtlama',
  'kvkk.turItiraz': 'İtiraz',
  'kvkk.gelisKanali': 'Geliş kanalı',
  'kvkk.gelisAni': 'Geliş anı',
  'kvkk.karariVer': 'Karara bağla',
  'kvkk.karar': 'Karar',
  'kvkk.kararYerineGetirildi': 'Yerine getirildi',
  'kvkk.kararKismen': 'Kısmen yerine getirildi',
  'kvkk.kararRet': 'Reddedildi',
  'kvkk.erisimPaketi': 'Erişim paketi üret',
  'kvkk.muhafazaKoy': 'Hukuki muhafaza koy',
  'kvkk.varlikKimligi': 'Varlık kimliği',
  'kvkk.muhafazaNeOlacak':
    'Bu kayıt düzeltilemez, anonimleştirilemez ve imha edilemez hâle gelecek.',
  'kvkk.muhafazaNeKalacak':
    'Okuma etkilenmez; muhafaza kaldırıldığında engel de kalkar.',
  'kvkk.muhafazaKaldir': 'Muhafazayı kaldır',
  'kvkk.olayKarari': 'Olayı karara bağla',
  'kvkk.olayYeniDurum': 'Yeni durum',
  'kvkk.olayInceleniyor': 'İnceleniyor',
  'kvkk.olayCozuldu': 'Çözüldü',
  'kvkk.olayYanlisAlarm': 'Yanlış alarm',
  'kvkk.anonimlestir': 'Kişiyi anonimleştir',
  'kvkk.talepKimligi': 'İlgili başvuru kimliği',
  'kvkk.anonimNeOlacak':
    'Kişisel alanlar geri getirilemez biçimde silinecek; işlem geri alınamaz.',
  'kvkk.anonimNeKalacak':
    'İstatistik ve denetim kaydı kalır: kaydın var olduğu ve ne zaman anonimleştirildiği görünür.',
  'kvkk.belgeImha': 'Belge içeriğini imha et',
  'kvkk.imhaNeOlacak': 'Dosyanın içeriği depodan silinecek ve bir daha indirilemeyecek.',
  'kvkk.imhaNeKalacak':
    'Belge kaydı durur; indirme denemesi "içerik imha edildi" yanıtı alır.',

  'ortak.suresiz': 'süresiz',

  // ---- Faz 2 · geçiş (98. adım) ------------------------------------------
  'menu.grupGunluk': 'Günlük operasyon',
  'menu.gecisler': 'Giriş-çıkış',
  'gecis.aciklama':
    'Kapıdan geçen öğrencinin kaydı. İzinsiz çıkış engellenmez, kaydedilir ve uyarı üretir.',
  'gecis.ogrenciKimligi': 'Öğrenci kimliği',
  'gecis.yon': 'Yön',
  'gecis.yonGiris': 'Giriş',
  'gecis.yonCikis': 'Çıkış',
  'gecis.kanal': 'Kanal',
  'gecis.kanalManuel': 'Elle',
  'gecis.kanalQr': 'QR',
  'gecis.kanalNfc': 'NFC',
  'gecis.kanalKart': 'Kart',
  'gecis.kanalTurnike': 'Turnike',
  'gecis.kanalGps': 'GPS',
  'gecis.durumGecerli': 'Geçerli',
  'gecis.durumDuzeltildi': 'Düzeltildi',
  'gecis.durumIptal': 'İptal',
  'gecis.baslangic': 'Başlangıç',
  'gecis.bitis': 'Bitiş',
  'gecis.olayAni': 'Geçiş anı',
  'gecis.olayAniAciklama': 'Boş bırakılırsa şu an kaydedilir.',
  'gecis.kayitAni': 'Kayıt anı',
  'gecis.kaydet': 'Geçiş kaydet',
  'gecis.qrUret': 'QR kodu üret',
  'gecis.qrHarca': 'QR kodu okut',
  'gecis.qrKod': 'Kod',
  'gecis.duzelt': 'Düzelt',
  'gecis.bosBaslik': 'Henüz geçiş kaydı yok',
  'gecis.bosAciklama': 'Bu süzgeçlerle eşleşen bir giriş-çıkış kaydı bulunamadı.',
  'gecis.iceridePaneli': 'Bir öğrencinin şu anda içeride olup olmadığını sorun.',
  'gecis.icerideSor': 'Sor',
  'gecis.icerideEvet': 'Şu anda içeride.',
  'gecis.icerideHayir': 'Şu anda dışarıda.',
  'gecis.icerideBilinmiyor': 'Bilinmiyor — bu öğrenci için hiç geçiş kaydı yok.',

  // ---- Faz 2 · izin (99. adım) -------------------------------------------
  'menu.izinler': 'İzinler',
  'izin.aciklama':
    'Çıkışın meşruiyeti. Reşit olmayan öğrencinin izni, veli onayı olmadan onaylanamaz.',
  'izin.tur': 'Tür',
  'izin.turGunluk': 'Günlük',
  'izin.turHaftaSonu': 'Hafta sonu',
  'izin.turUzun': 'Uzun süreli',
  'izin.turSaglik': 'Sağlık',
  'izin.durumTalep': 'Talep',
  'izin.durumOnayli': 'Onaylı',
  'izin.durumReddedildi': 'Reddedildi',
  'izin.durumKullaniliyor': 'Kullanılıyor',
  'izin.durumTamamlandi': 'Tamamlandı',
  'izin.durumGecDonus': 'Geç dönüş',
  'izin.durumIptal': 'İptal',
  'izin.donem': 'Planlanan dönem',
  'izin.baslangic': 'Çıkış',
  'izin.bitis': 'Dönüş',
  'izin.hedefAdres': 'Gidilecek adres',
  'izin.hedefTelefon': 'Ulaşılacak telefon',
  'izin.veliOnayi': 'Veli onayı',
  'izin.veliOnayGerekcesi': 'Veli onayının kaydı',
  'izin.veliOnayAni': 'Veli onayı anı',
  'izin.veliOnaySonucu': 'Veli ne dedi',
  'izin.veliOnayAlindi': 'Onay verdi',
  'izin.veliOnayReddedildi': 'Onay vermedi',
  'izin.veliOnayiKaydet': 'Veli onayını kaydet',
  'izin.talepGerekcesi': 'Talep gerekçesi',
  'izin.kararGerekcesi': 'Karar gerekçesi',
  'izin.kararAni': 'Karar anı',
  'izin.talepEt': 'İzin talebi aç',
  'izin.onayla': 'Onayla',
  'izin.reddet': 'Reddet',
  'izin.iptalEt': 'İptal et',
  'izin.iptalBaslik': 'İzin iptal edilecek',
  'izin.iptalNeOlacak': 'İzin iptal olacak ve bu izinle çıkış yapılamayacak.',
  'izin.iptalNeKalacak': 'Kayıt durur: kim, ne zaman ve neden iptal etti denetim izinde kalır.',
  'izin.iptalOnay': 'İptal edileceğini anladım',
  'izin.detayBaslik': 'İzin',
  'izin.bosBaslik': 'Henüz izin kaydı yok',
  'izin.bosAciklama': 'Bu süzgeçlerle eşleşen bir izin bulunamadı.',

  // ---- Faz 2 · yoklama (100. adım) ---------------------------------------
  'menu.yoklamalar': 'Yoklama',
  'menu.yoklamaSaatleri': 'Yoklama saatleri',
  'yoklama.aciklama':
    'Gözlem: bir insan bakar ve işaretler. Geçiş kaydından türetilmez; çeliştiklerinde uyarı üretilir.',
  'yoklama.planlananAn': 'Yoklama anı',
  'yoklama.acilisKaynagi': 'Açan',
  'yoklama.kapanisAni': 'Kapanış anı',
  'yoklama.durumAcik': 'Açık',
  'yoklama.durumTamamlandi': 'Tamamlandı',
  'yoklama.durumIptal': 'İptal',
  'yoklama.kurumKimligi': 'Yurt kimliği',
  'yoklama.ac': 'Yoklama aç',
  'yoklama.kapat': 'Yoklamayı kapat',
  'yoklama.kapatBaslik': 'Yoklama kapatılacak',
  'yoklama.kapatNeOlacak': 'Kapanmış yoklamaya işaret konamaz.',
  'yoklama.kapatNeKalacak': 'Bütün satırlar ve çelişki uyarıları olduğu gibi kalır.',
  'yoklama.kapatOnay': 'Kapatılacağını anladım',
  'yoklama.isaretle': 'İşaretle',
  'yoklama.sonuc': 'Sonuç',
  'yoklama.sonucVar': 'Var',
  'yoklama.sonucYok': 'Yok',
  'yoklama.sonucIzinli': 'İzinli',
  'yoklama.sonucHasta': 'Hasta',
  'yoklama.sonucBilinmiyor': 'İşaretlenmedi',
  'yoklama.satirAciklamasi': 'Açıklama',
  'yoklama.celiski': 'Çelişki',
  'yoklama.satirlar': 'Yoklama satırları',
  'yoklama.satirYok': 'Bu yoklamanın satırı yok.',
  'yoklama.detayBaslik': 'Yoklama',
  'yoklama.bosBaslik': 'Henüz yoklama yok',
  'yoklama.bosAciklama': 'Bu süzgeçlerle eşleşen bir yoklama bulunamadı.',
  'yoklama.saat': 'Saat',
  'yoklama.bugunkuSaat': 'Bugünkü saat',
  'yoklama.aktif': 'Etkin',
  'yoklama.saatBelirle': 'Saat belirle',
  'yoklama.istisnaYaz': 'Bir günlük değiştir',
  'yoklama.istisnaGunu': 'Gün',
  'yoklama.saatAciklama': 'SS:DD biçiminde, yurdun saatiyle.',
  'yoklama.gunAciklama': 'YYYY-AA-GG biçiminde. Geçmiş bir gün yazılamaz.',
  'yoklama.saatAciklamaEkran':
    'Her yurt kendi yoklama saatini belirler. Saati olmayan yurtta yoklama kendiliğinden açılmaz.',
  'yoklama.saatBosBaslik': 'Hiçbir yurdun saati belirlenmemiş',
  'yoklama.saatBosAciklama':
    'Saat belirlenene kadar yoklama elle açılır; zamanlanmış iş bu yurtları atlar ve kayda geçirir.',

  // ---- Faz 2 · ziyaretçi (101. adım) -------------------------------------
  'menu.ziyaretler': 'Ziyaretçiler',
  'ziyaret.aciklama':
    'Yurda gelen ziyaretçinin kaydı. Engellenen ziyaretçi silinmez; kararı gerekçesiyle durur.',
  'ziyaret.girisAni': 'Giriş',
  'ziyaret.cikisAni': 'Çıkış',
  'ziyaret.ad': 'Ad',
  'ziyaret.soyad': 'Soyad',
  'ziyaret.kimlikNo': 'Kimlik numarası',
  'ziyaret.kimlikAciklama': 'Saklanır ama hiçbir ekranda geri gösterilmez; yalnız maskeli hâli görünür.',
  'ziyaret.telefon': 'Telefon',
  'ziyaret.acikSuzgeci': 'Çıkışı yapılmamış',
  'ziyaret.acikEvet': 'İçeride',
  'ziyaret.acikHayir': 'Çıkmış',
  'ziyaret.girisKaydet': 'Ziyaretçi girişi',
  'ziyaret.cikisKaydet': 'Çıkış',
  'ziyaret.engelle': 'Engelle',
  'ziyaret.engelBaslik': 'Ziyaretçi engellenecek',
  'ziyaret.engelNeOlacak': 'Bu ziyaretçi için yeni ziyaret kaydı açılamayacak.',
  'ziyaret.engelNeKalacak': 'Ziyaretçi kaydı ve geçmiş ziyaretleri silinmez; engelleme gerekçesiyle durur.',
  'ziyaret.engelOnay': 'Engelleneceğini anladım',
  'ziyaret.bosBaslik': 'Henüz ziyaret kaydı yok',
  'ziyaret.bosAciklama': 'Bu süzgeçlerle eşleşen bir ziyaret bulunamadı.',

  // ---- Boş yatak arama (34. adım) ----------------------------------------
  'yapi.odaKimligi': 'Oda kimliği',
  'yapi.musaitlikAni': 'Şu an boş olsun',
  'yapi.musaitlikAciklama':
    'Bir an yazıldığında, o anı kapsayan aktif yerleşimi olmayan yataklar listelenir. Bu liste bir rezervasyon değildir: atama anında yatak dolmuş olabilir.',
} as const;

/** Sözlükteki geçerli anahtarlar — var olmayan anahtar derlemede yakalanır (not 1). */
export type MetinAnahtari = keyof typeof TR;
